export const environment = {
  production: true,
     apiUrl:"https://www.api.billzbee.com/apiMailService",    
     // apiUrl:"http://localhost:3001/apiMailService",

     SMTP_HOST : 'mail.askvedha.com',
     SMTP_USER : 'ask@askvedha.com',
     SMTP_PASS : 'AskMe@$$',
     SMTP_PORT : 587,
     domainURL : 'www.askvedha.com'
};
